import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'
import { isArray } from 'lodash'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function getChildrenArray(childrenData) {
  return isArray(childrenData) ? childrenData : [childrenData]
}
